import React, { useState } from 'react';
import { useAppContext } from '../../../../shared/contexts/AppContextProvider';
import { SuggestionsAndLinksButton } from './styles/SuggestionsAndLinksStyles';
import { Col, Row } from 'reactstrap';
import FaqsAnswerModal from './FaqsAnswerModal';
import { FaqType } from './types/FaqsTypes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { MobileHeaderContainer } from './styles/MobileHeaderStyles';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { MobileButton, MobileButtonOrganizer } from './styles/MobileStyles';

const Faqs: React.FC = () => {
    const { faqsData } = useAppContext();
    const [selectedFaq, setSelectedFaq] = useState<FaqType|null>(null);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const { t } = useTranslation();
    const handleSelectFaq = (faq: FaqType) => {
        setSelectedFaq(faq)
        setIsOpen(true)
    }

    return (
        <div className='secaoBtnMobileFaq'>
            <FaqsAnswerModal
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                faq={selectedFaq}
                setFaq={setSelectedFaq}
            />
            <MobileButtonOrganizer>
                {
                    faqsData !== null ? faqsData.map((x) => (
                        <MobileButton
                            className='btn-generic--segundo ml-0'
                            key={x.id}
                            onClick={() => handleSelectFaq(x)}
                        >
                            {x.titulo}
                        </MobileButton>
                    )) : ''
                }
            </MobileButtonOrganizer>
        </div>

    )
}

export default Faqs;
